module.exports = __webpack_public_path__ + "static/media/autumn.27e91f5d.jpg";